/**
 * Convert the viewer's container-wide page index into the page number a
 * `DocumentChunk` is stored with.
 *
 * The viewer paginates the whole container, but `document_chunks.page_number`
 * is 1-based within the OWNING RESULT's own page list — the same space
 * `extracted_data[].page_number` uses. A container whose second result starts
 * at viewer page 3 therefore stores that page as 1, not 3. Persisting the
 * viewer index directly would file a hand-drawn highlight (OMA-592) against a
 * page the result does not have, and the viewer would never render it back.
 *
 * `resultOffset` is `viewerOffsetFor(result)` — the viewer index of the
 * result's FIRST page.
 */
export function resultLocalPageNumber(
  viewerPageIndex: number,
  resultOffset: number
): number {
  return Math.max(1, viewerPageIndex - resultOffset + 1);
}
